import useEntities from 'hooks/useEntities';
import RelationsEditable from 'components/RelationsEditable';

const AwardSponsors = ({ sourceEntityId, data, onChange }) => {
    const entities = useEntities();
    const sourceEntity = entities.Award;
    const targetEntity = entities.Sponsor;

    return (
        <RelationsEditable 
            data={data}
            sourceEntity={sourceEntity} 
            targetEntity={targetEntity}
            sourceEntityId={sourceEntityId}
            emptyMessage={`This ${sourceEntity.displayName} does not have any ${targetEntity.displayNamePlural}`}
            onChange={onChange}
        />
    )
}

export default AwardSponsors
